import PropTypes from "prop-types";

function Number({ value, property = {} }) {
  // Parse the value to ensure it's a valid number
  const numValue = parseInt(value, 10);

  // Only render if we have a valid number
  if (!isFinite(numValue) || isNaN(numValue)) {
    return null;
  }

  // Format the number using I18n
  const formattedNumber = I18n.toNumber(value, {
    precision: property.precision,
    separator: ",",
    delimiter: ".",
  });

  return (
    <span>
      {property.prefix && <span>{property.prefix} </span>}
      {formattedNumber}
      {property.postfix && <span> {property.postfix}</span>}
    </span>
  );
}

Number.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  property: PropTypes.shape({
    prefix: PropTypes.string,
    postfix: PropTypes.string,
    precision: PropTypes.number,
  }),
};

export default Number;
